<form [formGroup]="form" (ngSubmit)="submitForm()">
  <div
    [ngClass]="
      form.controls['name'].touched
        ? form.controls['name'].errors
          ? 'has-error'
          : 'has-success'
        : ''
    "
    class="mb-4"
  >
    <label for="name">{{ "blog." + type + "_label" | translate }}</label>
    <input
      id="name"
      type="text"
      [attr.placeholder]="'blog.' + type + '_placeholder' | translate"
      class="form-input"
      formControlName="name"
    />
    <small
      class="text-danger"
      *ngIf="form.controls['name'].touched && form.controls['name'].errors"
    >
      {{ "blog." + type + "_error" | translate }}</small
    >
  </div>
  <button type="submit" class="btn btn-primary w-full" [disabled]="isLoading">
    <ng-container *ngIf="isLoading; else alternateTranslation">
      <span
        class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"
      ></span>
      {{ "loading" | translate }}
    </ng-container>
    <ng-template #alternateTranslation>
      {{ "blog." + type + "_button" | translate }}
    </ng-template>
  </button>
</form>
